// extracted by mini-css-extract-plugin
export var breadcrumbs = "material-module--breadcrumbs--o-hcs";
export var crumb = "material-module--crumb--inv1R";
export var layout = "material-module--layout--m+VAh";
export var split = "material-module--split--twTIA";